export const getStarRating = (rating, scale = 5) => {
  if (!rating) return [];
  const roundedRating = Math.round(rating * 2) / 2;
  const fullStars = Math.floor(roundedRating);
  const halfStars = roundedRating % 1 !== 0 ? 1 : 0;
  const emptyStars = scale - fullStars - halfStars;

  return [
    ...Array(fullStars).fill('full'),
    ...Array(halfStars).fill('half'),
    ...Array(emptyStars).fill('empty'),
  ];
};
